export const colors = {
  priamry: "#fcfaf5",
  secondary: "#79323f",
  nav: "#0F0F0F",
  card: "#12171B",
};
